import { render, staticRenderFns } from "./WoozyBall.vue?vue&type=template&id=d81a6722&"
import script from "./WoozyBall.vue?vue&type=script&lang=js&"
export * from "./WoozyBall.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports